import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@coolblue-development/freddy';
import { Proposition } from './shared/Proposition.js';
export const StaticMobilePropositionRow = ({ proposition, ga4Params, changePhoneNumberButtonUrl, }) => (_jsx(Box, { sx: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
    }, hideFrom: "md", children: _jsx(Proposition, { proposition: proposition, ga4Params: {
            ...ga4Params,
        }, index: 1, changePhoneNumberButtonUrl: changePhoneNumberButtonUrl }) }));
//# sourceMappingURL=StaticMobilePropositionRow.js.map